module.exports = __webpack_public_path__ + "img/symbol_8.5cf57558.png";